const $ = require('jquery'),
      loadGoogleMapsApi = require('load-google-maps-api'),
      distFrom = require('distance-from');

/**
 * Build 
 * 
 * @param {object} $container The partners-container
 */
var partnersNavigator = function($container) {

    var $list = $container.find('.partners-list'),
        $partners = $list.find('.partner'),
        $mapContainer = $container.find('.partners-map'),
        $searchForm = $container.find('.partners-location-search'),
        $consent = $container.find('.partners-consent'),

        map = false,
        bounds = false,
        markers = [],
        infoWindow = false;

    var init = function() {
            
        loadGoogleMapsApi({
            key: window.location.hostname.search(/indamed\.de/) > 0 ?
            	'AIzaSyB6Nl37nSXYCqq79UquuHoKnDCGkzYNSNo' : // production google maps API key (INDAMED)
            	'AIzaSyA40k_2LRU4cdz_IZ9YX8RNe6PCAB1Pf9c',  // development google maps API key (Pitch)
            libraries: ['geometry']
        }).then(googleMaps => {
    
            map = new google.maps.Map($mapContainer.get(0));

            infoWindow = new google.maps.InfoWindow({
                content: ''
            });

            $partners.each((index, el) => {
    
                let $partner = $(el),
                    marker = new google.maps.Marker({
                        position: {
                            lat: parseFloat($partner.data('lat')),
                            lng: parseFloat($partner.data('lng'))
                        },
                        id: $partner.data('id'),
                        map,
                        animation: google.maps.Animation.DROP,
                        title: $partner.find('h3').text(),
                        icon: 'https://www.indamed.de/wp-content/themes/indamed/img/mo-marker2.png'
                    });

                markers.push(marker);

                marker.addListener('click', function() {
                    showInfoWindow(this.id);
                });
    
                $partner.find('.name').click(e => {
                    showInfoWindow($(e.target).closest('.partner').data('id'));
                });

            });

            fitMap(markers);

            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(position => {
                    findNearest(position.coords.latitude, position.coords.longitude);
                });
            }
    
        });

        $searchForm.submit(e => doLocationSearch());

    };

    var fitMap = function(markers, origin) {

        let bounds = new google.maps.LatLngBounds();

        markers.forEach(marker => {
            bounds.extend(marker.getPosition());

            if (origin) {

                let distance = google.maps.geometry.spherical.computeDistanceBetween(marker.getPosition(), origin);

                let circle = new google.maps.Circle({
                    fillOpacity: 0,
                    strokeOpacity: 0,
                    strokeWeight: 0,
                    center: origin,
                    radius: distance *1.25,
                    map: map
                });

                bounds = circle.getBounds();

            }

        });
        
        map.fitBounds(bounds);

        if (markers.length == 1 && map.getZoom() > 13) {
            map.setZoom(13);
        }

    };

    var findNearest = function(lat, lng) {

        markers.forEach((m,i) => {
            if (m.id == "origin") {
                m.setMap(null);
                markers.splice(i, 1);
            }
        });

        var origin = new google.maps.LatLng(lat, lng);

        var originMarker = new google.maps.Marker({
            position: origin,
            id: 'origin',
            map,
            title: 'Ihr Standort'
        });

        markers.push(originMarker);

        $partners.each((index, partner) => {

            var $partner = $(partner),
                partnerPos = {
                    lat: $(partner).data('lat'),
                    lng: $(partner).data('lng')
                };

            let distance = distFrom([lat, lng]).to([$partner.data('lat'), $partner.data('lng')]).in('km');

            $partner.data('distance', distance);
            $partner.find('.distance').text('Entfernung ca. ' + distance.toFixed(distance < 10 ? 2 : 0).replace('.',',') + ' km');          

        }).sort((a,b) => {
            return ($(b).data('distance')) < ($(a).data('distance')) ? 1 : -1;
        }).each((index, partner) => {
            $(partner).css('order', index);
        });
        
        let nearestId = $partners.first().data('id'),
            nearestMarker = markers.find(marker => marker.id == nearestId);

        fitMap([nearestMarker], origin);
        
        // window.setTimeout(() => showInfoWindow(nearestId), 500);

    };

    var doLocationSearch = function() {

        var input = $searchForm.find('input').val(),
            geocoder = new google.maps.Geocoder();

        geocoder.geocode({ address: input, region: 'de' }, (results, status) => {

            if (status == google.maps.GeocoderStatus.OK) {
                let pos = results[0].geometry.location;
                findNearest(pos.lat(), pos.lng());
            } else {
                alert('Ihr Ort oder Postleitzahl wurde nicht gefunden. Vielleicht haben Sie sich vertippt?');
            }

        });

        return false;

    };

    var showInfoWindow = function(partnerId) {

        let $partner = $partners.filter('[data-id=' + partnerId + ']'),
            marker = markers.find(marker => marker.id == partnerId);

        infoWindow.setContent(`
            <div class="partner-info-window">
                ${ $partner.html() }
            </div>
        `);

        infoWindow.open(map, marker);

    }

    init();

};

if (Cookiebot.consent.marketing) {
	$(".partners-navigator").each((index, el) => partnersNavigator($(el)));
} else {

	$(".partners-navigator").each((index, el) => {
	
		let $container = $(el);
		
		$container.find('.partners-consent').show();
		$container.find('.partners-list-map, .partners-location-search').hide();
		
	});
	
	window.addEventListener('CookiebotOnAccept', e => {
		if (Cookiebot.consent.marketing) {
			$(".partners-navigator").each((index, el) => {
				let $container = $(el);
				$container.find('.partners-consent').hide();
				$container.find('.partners-list-map, .partners-location-search').show();
				partnersNavigator($container);
			});
		}
	});

}


/*$('.partners-navigator').each((index, el) => {

    let $container = $(el),
        $list = $container.find('.partners-list'),
        $partners = $list.find('.partner'),
        $map = $container.find('.partners-map');

    var map = false,
        markers = [];

    

});*/
